export enum SortingTypeEnum {
    FirstName = 'firstName',
    LastName = 'lastName',
    LocalId = 'localId',
    displayName = 'displayName',
}
